import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BusinessUnitRole, ProviderBu } from '@dal/core';
import { normalizeBusinessUnitId } from '@dal/core';

@Component({
  selector: 'dal-provider-bu-inline-selector',
  templateUrl: './provider-business-unit-inline-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderBusinessUnitInlineSelectorComponent implements OnChanges {
  @Input() businessUnit: ProviderBu | null = null;
  @Input() businessUnits: BusinessUnitRole[] = [];
  @Output() businessUnitChange = new EventEmitter<number>();

  selectedId: number | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['businessUnit']) {
      this.selectedId = this.businessUnit ? this.businessUnit.id : null;
    }
  }

  onModelChange(raw: number | string | null) {
    const normalizedId = normalizeBusinessUnitId(raw);
    if (normalizedId == null) {
      this.revertSelection();
      return;
    }
    if (normalizedId === this.businessUnit?.id) {
      this.selectedId = this.businessUnit.id;
      return;
    }
    this.businessUnitChange.emit(normalizedId);
  }

  revertSelection() {
    if (this.businessUnit) {
      this.selectedId = this.businessUnit.id;
    }
  }
}
